module.exports = __webpack_public_path__ + "img/q-chevalier-site-web.0882587.png";